export const LIST_TABLE_REQUEST="LIST_TABLE_REQUEST";
export const LIST_TABLE_SUCCESS="LIST_TABLE_SUCCESS";
export const LIST_TABLE_FAIL="LIST_TABLE_FAIL";
export const SELECTED_SEQUENCE_DETAILS_REQUEST = "SELECTED_SEQUENCE_DETAILS_REQUEST";
export const SELECTED_SEQUENCE_DETAILS_SUCCESS="SELECTED_SEQUENCE_DETAILS_SUCCESS";
export const SELECTED_SEQUENCE_DETAILS_FAIL="SELECTED_SEQUENCE_DETAILS_FAIL";